import defaultLayout from '@/layouts/Default.vue';
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

const Home = () => import('@/views/Home.vue');
const Offer = () => import('@/views/Offer.vue');
const Booking = () => import('@/views/Booking.vue');

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:lang?',
    name: 'Home',
    component: Home,
    meta: { layout: defaultLayout },
  },
  {
    path: '/:lang?/reservation/:username/:id',
    name: 'ExistingReservation',
    component: Offer,
    meta: { layout: defaultLayout },
  },
  {
    path: '/booking/:username?/:id',
    name: 'BookingPageWithUser',
    component: Booking,
    meta: { layout: defaultLayout },
  },
  {
    path: '/booking/:id',
    name: 'BookingPage',
    component: Booking,
    meta: { layout: defaultLayout },
  },
  {
    path: '/:lang?/edit/:username/:id',
    name: 'EditReservation',
    component: Home,
    props: {
      existingReservation: true,
    },
    meta: { layout: defaultLayout },
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

router.onError((error) => {
  console.error('Global router error:', error);
  // You could also add global fallback logic here if needed
});

export default router;
